import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FieldDataSheet } from '../../../_models/field';
import { PortalApiService } from '../../../_services/portal-api.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-jump-to-datasheet',
  templateUrl: './jump-to-datasheet.component.html',
  providers: [DatePipe]
})
export class JumpToDatasheetComponent implements OnInit {
  @Input() datasheetID: number;
  @Input() entryDate: string;
  @Input() fieldID: number; nextDatasheet: FieldDataSheet;
  previousDatasheet: FieldDataSheet;
  currentDatasheet: FieldDataSheet;
  loadingDatasheetOptions: boolean;
  startDate: string;
  endDate: string;
  receivedDatasheets: FieldDataSheet[] = [];
  jumpingToDatasheet: boolean = false;
  newEntryDate: Date;
  minimumDate: Date;
  maximumDate: Date;
  visible: boolean = false;

  constructor(
    private apiService: PortalApiService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
  ) {
    this.setDateRange();
  }

  ngOnInit(): void {
    this.getDatasheetOptions();
  }

  setDateRange() {
    const startDate = new Date();
    const endDate = new Date();

    // Get data sheets in the last 30 days
    startDate.setMonth(endDate.getMonth() - 1);

    this.startDate = this.datePipe.transform(startDate, 'yyyy-MM-dd');
    this.endDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');
  }

  calculateDiffDays(startDate: Date, endDate: Date): number {
    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  }

  getDatasheetOptions() {
    this.loadingDatasheetOptions = true;

    this.apiService.getFieldDataSheets(this.fieldID, this.startDate, this.endDate).subscribe({
      next: (data: FieldDataSheet[]) => {
        this.receivedDatasheets = data;

        let currentDatasheetIndex: number;
        currentDatasheetIndex = this.receivedDatasheets.findIndex(datasheet => datasheet.dataSheetID == this.datasheetID);
        this.currentDatasheet = this.receivedDatasheets[currentDatasheetIndex];

        if (currentDatasheetIndex > 0) {
          this.nextDatasheet = this.receivedDatasheets[currentDatasheetIndex - 1];
        }

        if (currentDatasheetIndex < (this.receivedDatasheets.length - 1)) {
          this.previousDatasheet = this.receivedDatasheets[currentDatasheetIndex + 1];
        }
        this.loadingDatasheetOptions = false;

        let firstDatasheet: any = this.receivedDatasheets[this.receivedDatasheets.length - 1].entryDate;
        this.minimumDate = new Date(firstDatasheet);
        let lastDatasheet: any = this.receivedDatasheets[0].entryDate;
        this.maximumDate = new Date(lastDatasheet);
      },
      error: err => {
        console.log(err);
        this.loadingDatasheetOptions = false;
      }
    });
  }

  onDatasheetSelect(newDatasheetID: any, newEntryDate: any) {
    let formattedNewEntryDate = this.datePipe.transform(newEntryDate, 'yyyy-MM-dd');

    let urlPathToBeReplaced: string = '/datasheet/' + this.datasheetID + '/entrydate/' + this.entryDate + '/run-tickets';
    let urlPathParts: string[] = this.router.url.split(urlPathToBeReplaced);

    let newDatasheetPath: string = '/datasheet/' + newDatasheetID + '/entrydate/' + formattedNewEntryDate + '/run-tickets';
    urlPathParts.splice(1, 0, newDatasheetPath);
    let newRoute: string = urlPathParts.join('');

    this.router.navigate([newRoute]).then(() => {
      window.location.reload();
    });
  }

  openDatasheetCalendar() {
    this.visible = true;
  }

  navigateToCalendar() {
    const path: string = `app/Portal/dataentry/field/${this.fieldID}`;
    this.router.navigate([path]);
  }

  updateDateChange() {
    this.jumpingToDatasheet = true;
    let formattedDate: any = this.datePipe.transform(this.newEntryDate, 'yyyy-MM-dd') + "T00:00:00";
    let indexFound = this.receivedDatasheets.findIndex(datasheet => datasheet.entryDate == formattedDate);
    if (indexFound > -1) {
      this.onDatasheetSelect(this.receivedDatasheets[indexFound].dataSheetID, this.newEntryDate);
    }
    else {
      this.jumpingToDatasheet = false;
    }
  }
}
